import { render } from "./marine.vue?vue&type=template&id=240779fc&scoped=true"
import script from "./marine.vue?vue&type=script&lang=js"
export * from "./marine.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-240779fc"

export default script